import React from 'react';
import { Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import { axiosGet } from '../util/apiConfig';

const REFRESH_MS = 60000;

// Same roles that can reach the Session Monitor sidebar entry (src/routes.js) — anyone
// outside this list will never see anything useful here, so skip polling for them
// entirely rather than hitting the endpoint every 60s just to silently discard a 401/403.
// Keep in sync with routes.js if that list ever changes.
const ALLOWED_ROLES = ['admin', 'sub_admin', 'support', 'sales_support', 'sales_ops'];

// Same "alert" definition as Session Monitor (src/views/examples/SessionMonitor.jsx):
// a class whose start time has passed and the teacher still hasn't joined. Lives in the
// top navbar (not a specific page) so ops sees it regardless of what they're working on.
class SessionAlertBadge extends React.Component {
  state = { alertCount: null };

  componentDidMount() {
    if (!ALLOWED_ROLES.includes(localStorage.getItem('userRole'))) return;
    this.load();
    this.timer = setInterval(this.load, REFRESH_MS);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  load = () => {
    axiosGet('session-monitor')
      .then((res) => {
        if (res && !res.isError) {
          this.setState({ alertCount: res.data.alertCount });
        }
      })
      .catch(() => {}); // passive widget — stay silent rather than show a stale/wrong count
  };

  render() {
    const { alertCount } = this.state;
    if (!alertCount) return null;
    return (
      <Link to="/admin/session-monitor" style={{ textDecoration: 'none' }}>
        <Badge
          color="danger"
          pill
          style={{ fontSize: '0.85rem', padding: '0.5em 0.9em', cursor: 'pointer' }}
          title="Classes where the teacher hasn't joined — click to open Session Monitor"
        >
          {`⚠ ${alertCount} class${alertCount === 1 ? '' : 'es'} impacted`}
        </Badge>
      </Link>
    );
  }
}

export default SessionAlertBadge;
